import { render, staticRenderFns } from "./toolsTranscribe.vue?vue&type=template&id=5953ec5b&scoped=true"
import script from "./toolsTranscribe.vue?vue&type=script&lang=js"
export * from "./toolsTranscribe.vue?vue&type=script&lang=js"
import style0 from "./toolsTranscribe.vue?vue&type=style&index=0&id=5953ec5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953ec5b",
  null
  
)

export default component.exports